<template>
  <div class="map-container">
    <template v-if="markers.length <= 0">
      <p style="color: red">Missing map markers</p>
    </template>
    <template v-else>
      <ul class="map-menu">
        <li v-for="(marker, index) in markers" v-show="index < 6" class="marker-info" :class="{'active': marker.active}" :style="'background-image: url(' + marker.logo + ')'" :key="index">
          <a href="#click" @click.prevent="toggleActive(marker, index)" ref="menuItem">
            <span class="marker-info-title" v-html="marker.title"></span>
            <span class="marker-info-description" v-html="marker.description"></span>
            <span class="marker-info-rating">
              <star-rating :rating="marker.rating" :active="marker.active"></star-rating>
            </span>
          </a>
        </li>
      </ul>
      <div class="map">
        <gmap-map :options="options" :center="options.center" style="width: 100%; height: 100%" ref="map">
          <gmap-info-window v-if="popupActive" :options="popupOptions" :opened="true" :position="popupPosition" :content="popupContent" @closeclick="toggleActive(activeMarker, activeMarkerIndex)"></gmap-info-window>
          <gmap-marker v-for="(marker, index) in markers" :position="marker.position" :icon="getMarkerIcon(marker, index)" :clickable="markerOptions.clickable" @mouseover="toggleActive(marker, index)" :key="index"></gmap-marker>
        </gmap-map>
      </div>
    </template>
  </div>
</template>

<script>

  import StarRating from './StarRating.vue'
  
  export default {
    name: 'Map',
    components: {
      StarRating
    },
    data() {
      return {
        ready: false,
        options: {
          center: {
            lat: 25.7823198,
            lng: -80.2660227
          },
          zoom: 10,
          disableDefaultUI: true,
          zoomControl: true
        },
        popupOptions: {
          pixelOffset: {
            width: 0,
            height: -30
          }
        },
        markerOptions: {
          clickable: true,
          centerOnActive: false
        },
        markers: []
      }
    },
    computed: {
      activeMarkerIndex() {
        return _.findIndex(this.markers, {active: true})
      },
      activeMarker() {
        return _.find(this.markers, {active: true})
      },
      activeMarkerEl() {
        return $(this.$el).find('.marker-info:eq(' + this.activeMarkerIndex + ')')
      },
      popupActive() {
        return this.activeMarkerIndex !== -1 && this.ready
      },
      popupPosition() {
        return _.get(this.activeMarker, 'position', false)
      },
      popupContent() {
        var marker = this.activeMarker
        
        return '<div class="marker-info" style="background-image: url(' + marker.logo + ')">' + this.activeMarkerEl.find('a').html() + '<a href="#reserve">Reserve</a></div>'
      }
    },
    watch: {
      activeMarker(val, oldVal) {
        if (this.markerOptions.centerOnActive && typeof val === 'object') {
          this.centerMap(val.position)
        }
      }
    },
    methods: {
      getMarkerIcon(marker, index) {
        return marker.active ? '/dist/pin-active.png' : '/dist/pin.png'
      },
      toggleActive(marker, index) {
        this.markers = _.map(this.markers, function (_marker, _index) {
          if (index === _index) {
            _marker.active = !_marker.active
          } else {
            _marker.active = false
          }

          return _marker
        })
      },
      toggleAllActive() {
        this.markers = _.map(this.markers, function (marker) {
          marker.active = true

          return marker
        });
      },
      toggleAllInactive() {
        this.markers = _.map(this.markers, function (marker) {
          marker.active = false

          return marker
        });
      },
      updateMarkers(markersObj) {
        this.markers = _.map(markersObj, function (marker, index) {
          marker.id = index

          return marker
        })
      },
      centerMap(position) {
        this.$refs.map.panTo(position)
      }
    },
    created() {
      this.options = Object.assign({}, this.options, _.get(window, 'map.options', {}))
      this.markers = _.get(window, 'map.markers', [])
    },
    mounted() {
      this.ready = true
    }
  }

</script>


// WEBPACK FOOTER //
// Map.vue?951a19e6